import React, { useEffect } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View,Linking } from "react-native";
import CImage from "../../common/CImage";
import { COLORS, FONTS } from "../../constant";
import useStyles from "./LoginRightWidget_Styles";
const isSmallDevice = Dimensions.get('window').width < 767

export default function LoginRightWidget(props) {
    const styles = useStyles();

    return (
        <View style={styles.bodyRightViewStyle}>
            <View style={styles.rightViewStyle}>
                <View style={styles.firstForwardViewStyle}>
                    <Text style={styles.idfcTextStyle}>
                        {"Keep Moving"}
                    </Text>
                    <Text style={{fontFamily: FONTS.InterBold,fontSize: 55, color: "#9c1d25",}}>
                        {"Forward"}
                    </Text>
                    <Text style={styles.keepMvngTextStyle}>
                        {"With IDFC FIRST Bank FASTag"}
                    </Text>
                    <CImage.FFLogo></CImage.FFLogo>
                </View>

                <View style={styles.qrViewStyle}>
                    <CImage.QRCodeIcon></CImage.QRCodeIcon>
                    <View style={{ paddingLeft: 20 }}>
                        <Text style={{fontFamily: FONTS.Inter,fontSize: 20,color: "#54565b", }} >
                            {`Scan QR to Download the app`}
                        </Text>
                    </View>
                </View>
                <TouchableOpacity style={styles.whatsupTextLink} onPress={()=>Linking.openURL("https://api.whatsapp.com/send?phone=919555555555&text=FASTag")}>
                    <CImage.WhatsAppIcon></CImage.WhatsAppIcon>
                    <Text style={styles.whatsupText}>{"Chat with us on WhatsApp"}</Text>
                </TouchableOpacity>

            </View>

            <Image
                source={require("../../assets/images/maskGroup1.png")}
                style={styles.imageStyle}
            />
        </View>

    );
}



